module.exports = __webpack_public_path__ + "static/logo-26b9ab17a2863e9d2e767185006682dd.png";